import moment from 'moment';

const regexNumComma = /\B(?=(\d{3})+(?!\d))/g;

export const formatAmount = (data: any): string => {
  if (data == null || data === '') {
    return '';
  }

  const num = Number(String(data).replace(/,/g, ''));

  if (isNaN(num)) {
    return '';
  }
  return String(num).replace(regexNumComma, ',');
};

const FORMAT_DATETIME = 'DD/MM/YYYY, HH:mm:ss';

export const formatDate = (date?: Date | null) => (date ? moment(date).format(FORMAT_DATETIME) : '-');
